<template>
  <div class="submitOutcome">
    <div class="submitOutcome-top">
      <div class="top-con">
        <div class="container">
          <div class="submitOutcome-title">
            卖家信息表单
          </div>
          <span>订单编号：{{ order_no }}</span>
        </div>
        <div class="logo"></div>
      </div>
    </div>
    <div class="submitOutcome-main">
      <div class="submitOutcome-content">
        <div class="submitOutcome-content-img">
          <template v-if="auditStatus == 1">
            <img src="@/assets/image/Contract/submitOutcome/audit.png"/>
          </template>
          <template v-else-if="auditStatus == 2">
            <img src="@/assets/image/Contract/submitOutcome/succeed.png"/>
          </template>
          <template v-else-if="auditStatus == 3">
            <img src="@/assets/image/Contract/submitOutcome/fail.png"/>
          </template>
          <template v-else-if="auditStatus == 4">
            <img src="@/assets/image/Contract/submitOutcome/cancel.png"/>
          </template>
        </div>
        <div class="submitOutcome-content-text">
          <template>
            <div>资料已成功提交</div>
            <!-- <div>客服正在加速审核中</div> -->
          </template>
          <!-- <template v-else-if="auditStatus == 2">
            <div>资料审核已通过</div>
          </template>
          <template v-else-if="auditStatus == 3">
            <div class="failTitle">资料审核不通过</div>
            <div class="reasonForFail">审核不通过的原因为：{{description}}</div>
          </template>
          <template v-else-if="auditStatus == 4">
            <div class="failTitle">资料审核已取消</div>
            <div>原因：订单取消</div>
          </template> -->
        </div>
        <div class="submitOutcome-btn" :class="{'submitOutcome-btn-again':auditStatus == 3}">
          <!-- <template v-if="auditStatus == 1">
            <div class="submitOutcome-btn-tip">审核约<span>5分钟</span>，请耐心等待，并关注系统消息</div>
          </template> -->
          <!-- <template v-else-if="auditStatus == 2">
            <div class="submitOutcome-btn-tip">合同起草约<span>5分钟</span>左右，请耐心等待</div>
          </template> -->
          <!-- <template v-else-if="auditStatus == 3">
            <div class="btn" @click="aginSub">重新提交</div>
          </template> -->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { apiContractSellerInformation } from "../../request/API";
export default {
  name: 'submitSuccess',
  data() {
    return {
      //审核状态 1：待审核 2：成功 3：失败 4：取消
      auditStatus: 1,
      order_id: '',
      room_id: '',
      admin_id: '',
      order_no: '',
      userToken: '',
      app_status: 1,
      description: '',
    }
  },
  created() {
    this.order_id = this.$route.query.o
    this.room_id = this.$route.query.r
    this.admin_id = this.$route.query.a
    this.userToken = this.$route.query?.t || this.$route.query?.token
    if(this.userToken){
      let status = true
      this.$store.commit('set_token', this.userToken)
      this.$store.commit('set_loginStatus', status)
      this.app_status = 2
    } else{
      if (this.$store.state.loginStatus) {
        this.app_status = 1
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath
          },
        })
        return;
      }
    }

    apiContractSellerInformation({
      rd: this.$route.query.rd,
      order_id: this.order_id,
      client: this.userToken ? 'moblie' : 'front'
    }).then(res => {
      // this.auditStatus = res.data.status
      this.order_no = res.data.order_no
      this.description = res.data.description
      // status  0: 待审核 1：审核通过 2：审核不通过
      let status = res.data.status
      this.auditStatus = status == 0 ? 1 : status == 1 ? 2 : status == 2 ? 3 : status == 3 ? 4 : ''
    })
  },
  methods: {
    aginSub(){
      location.href = `/sellerInformation?r=${this.room_id}&a=${this.admin_id}&f=1&o=${this.order_id}${this.userToken?'&t=' + this.userToken: ''}`
      // this.$router.push({
      //   path: '/sellerInformation',
      //   query: {
      //     o: this.order_id,
      //     r: this.room_id,
      //     a: this.admin_id,
      //     t: this.userToken,
      //     f: 1
      //   },
      // })
    }
  },
}
</script>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page(
  72px,
  submitOutcome,
  submitOutcome-top,
  submitOutcome-main,
  submitOutcome-btn
);
.contract-feedback-layout(submitOutcome, submitOutcome-main, submitOutcome-content, 560px, 420px);

.submitOutcome {
  min-height: 100vh;

  &-title {
    font-size: 24px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    margin: 0 0 8px;
  }

  &-content {
    padding: 0 24px;
    box-sizing: border-box;
    position: relative;

    &-img {
      img {
        display: block;
        width: 250px;
        height: 250px;
        object-fit: contain;
      }
    }

    &-text {
      margin-top: 20px;

      div {
        text-align: center;
      }

      div:first-of-type {
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-main, #1A1D24);
        margin: 0 0 4px;
      }

      div:last-of-type {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--text-secondary, #5A5F6B);
      }

      .failTitle {
        color: #D06666;
      }

      .reasonForFail {
        width: 321px;
        text-align: left;
        line-height: 22px;
      }
    }
  }

  &-main {
    .submitOutcome-btn {
      position: absolute;
      bottom: 20px;
      margin-top: 0;

      &-tip {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--text-secondary, #5A5F6B);

        span {
          color: var(--primary, #FF5A1F);
        }
      }

      .btn {
        width: 250px;
        height: 50px;
        line-height: 50px;
        border-radius: 3px;
        border: 0;
        background: var(--primary, #FF5A1F);
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        cursor: pointer;
        transition: all .2s ease;

        &:hover,
        &:focus {
          background: var(--primary-hover, #E84A12);
          box-shadow: 0 8px 18px rgba(255, 90, 31, 0.22);
        }

        &:active {
          background: var(--primary-hover, #E84A12);
          box-shadow: 0 4px 12px rgba(255, 90, 31, 0.18);
        }
      }
    }

    .submitOutcome-btn-again {
      position: static;
      margin-top: 40px;
    }
  }

  @media screen and (max-width: 900px) {
    &-title {
      font-size: 22px;
    }

    &-content {
      &-img {
        img {
          width: 125px;
          height: 125px;
        }
      }

      &-text {
        margin-top: 30px;

        div:first-of-type {
          font-size: 20px;
          margin: 0 0 8px;
        }

        .reasonForFail {
          width: 231px;
        }
      }
    }

    &-main {
      .submitOutcome-btn {
        bottom: 50px;

        &-tip {
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
        }

        .btn {
          width: 250px;
          max-width: 80vw;
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    &-title {
      font-size: 20px;
    }
  }
}
</style>
